<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Toolbox-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'Company name look-up'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Toolbox.CompanyNameLookup"
							>
								<div
									class="layout-block vertical"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<ng-container *ngIf="Sys.User.currentUser; else else56"
										><div
											class="layout-block"
											[style.align-items]="'inherit'"
											[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[style.--layout-column-count]="3"
											[style.gap]="'1em 2em'"
										>
											<h2
												[style.grid-column]="'span ' + (1)"
												[innerHtml]="'Step 1: Paste a list of company names that you want to match against the known companies' | escapeHtml: 'none' | replaceNewlines: 'h2'"
											></h2>
											<h2
												[style.grid-column]="'span ' + (1)"
												[innerHtml]="'Step 2: Pick the right company where none or multiple possible matches were found' | escapeHtml: 'none' | replaceNewlines: 'h2'"
											></h2>
											<h2
												[style.grid-column]="'span ' + (1)"
												[innerHtml]="'Step 3: Use the output of the matching (e.g. copy into Excel)' | escapeHtml: 'none' | replaceNewlines: 'h2'"
											></h2>
											<div
												class="layout-block vertical"
												[style.grid-column]="'span ' + (1)"
												[style.align-items]="'inherit'"
												[style.gap]="'1em'"
											>
												<mat-form-field appearance="fill">
													@let $fc_4_1 = getFormControl(screen,
													'companiesQuery', 4, $scope, $formDirective,
													$disabled, $ignoreValidations);
													<mat-label
														[innerHtml]="'Companies to be searched' | escapeHtml"
													></mat-label>
													<textarea
														#input_4
														[formControl]="$fc_4_1"
														matInput
														[rows]="20"
													></textarea>

													<button
														*ngIf="input_4.value == ''"
														mat-icon-button
														matSuffix
														(click)="input_4.value = ''; $dispatchInputEvent(input_4)"
													>
														<mat-icon>close</mat-icon>
													</button>
												</mat-form-field>

												<div
													class="layout-block"
													[style.align-items]="'baseline'"
													[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
													[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
													[style.gap]="'1em'"
												>
													<mat-form-field appearance="fill">
														@let $fc_47_1 = getFormControl(screen,
														'companyType', 47, $scope, $formDirective,
														$disabled, $ignoreValidations);

														<mat-label
															[innerHtml]="'Match against' | escapeHtml"
														></mat-label>
														<mat-select
															[formControl]="$fc_47_1"
															[compareWith]="$compare"
															#select_47="matSelect"
															[lgFormComponent]="select_47"
															[lgFormValue]="screen.companyType"
															canSelectNullableOptions
															[multiple]="false"
														>
															@let emptyOption_47 = null; @if
															(emptyOption_47) {
															<mat-option [value]="emptyOption_47[0]"
																>{{ emptyOption_47[1] }}</mat-option
															>
															}

															<mat-option
																*ngFor="let $option of (Toolbox.CompanyNameMatchingCompanyType.getChoices('$displayValue')); let $index = index"
																[value]="Toolbox.CompanyNameMatchingCompanyType.getEntry($option.id)"
															>
																<span
																	[innerHtml]="$option.label | escapeHtml"
																	style="margin: auto 0"
																></span>
															</mat-option>
														</mat-select>
													</mat-form-field>
													<mat-form-field
														*ngIf="$any(screen.companyType)?.$isOther"
													>
														@let $fc_47_3 =
														getFormControl(screen.companyType,
														'$otherValue', 47, $scope, $formDirective,
														$disabled, $ignoreValidations);
														<mat-label
															[innerHtml]="'Match against' + ' (Other)' | escapeHtml"
														></mat-label>
														<input
															type="text"
															matInput
															[formControl]="$fc_47_3"
														/>
													</mat-form-field>
												</div>
												<div
													class="layout-block"
													[style.align-items]="'inherit'"
													[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
													[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
													[style.gap]="'1em'"
												>
													<button
														mat-raised-button
														class="has-click-handler"
														color="primary"
														(click)="handler_ButtonBlock_7_click_executeMatching_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<mat-icon>{{'send'}}</mat-icon
														><span
															[innerHtml]="'Execute matching' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
												</div>
												<ng-container *ngIf="screen.matchingStats"
													><div
														class="layout-block vertical"
														[style.align-items]="'inherit'"
														[style.gap]="'0.5em'"
													>
														<span
															[innerHtml]="`${screen.matchingStats.total} company names processed` | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
														<span
															style="color: green"
															[innerHtml]="`${screen.matchingStats.total - screen.matchingStats.notFound - screen.matchingStats.ambiguous} successful matches` | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
														<span
															style="color: lightseagreen"
															[innerHtml]="`${screen.matchingStats.ambiguous} ambiguous matches` | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
														<span
															style="color: orange"
															[innerHtml]="`${screen.matchingStats.notFound} companies couldn't be matched` | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span></div
												></ng-container>
											</div>
											<div
												class="layout-block vertical"
												[style.grid-column]="'span ' + (1)"
												[style.align-items]="'inherit'"
												[style.gap]="'1em'"
											>
												<ng-container *ngIf="screen.matching"
													><ng-container
														*ngIf="screen.matching.resolutions.every(res => res.options.length == 1)"
														><span
															[innerHtml]="'Everything could be matched successfully, please proceed to the next step' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span
													></ng-container>

													<div
														class="layout-block vertical"
														style="height: 900px"
														[style.align-items]="'inherit'"
														[style.gap]="'1em'"
													>
														<div
															class="layout-block block"
															style="overflow-y: auto"
															[style.flex]="'1 1 auto'"
															[style.align-items]="'inherit'"
															[style.gap]="'1em'"
														>
															<ng-container
																*ngFor="let resolution of screen.matching.resolutions; let resolutionIndex = index; trackBy: trackByAutomatic"
															>
																<ng-container
																	*lowgileScope="resolution; as: 'resolution'; let $scope"
																>
																	<ng-container
																		*lowgileScope="resolutionIndex; as: 'resolutionIndex'; let $scope"
																	>
																		<ng-container
																			*ngIf="resolution.inputName"
																			><ng-container
																				*ngIf="resolution.options.length > 1; else else20"
																				><div
																					class="layout-block"
																					[style.align-items]="'baseline'"
																					[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																					[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																					[style.gap]="'1em'"
																				>
																					<mat-form-field
																						class="has-selectionChange-handler"
																						appearance="fill"
																						[style.flex]="'1 0 auto'"
																						(selectionChange)="handler_DropdownBlock_28_selectionChange_updateOutput_0($event, { resolution, resolutionIndex, $disabled: $disabled })"
																					>
																						@let
																						$fc_28_1 =
																						getFormControl(resolution,
																						'chosenOption',
																						28, $scope,
																						$formDirective,
																						$disabled,
																						$ignoreValidations);

																						<mat-label
																							[innerHtml]="resolution.inputName | escapeHtml"
																						></mat-label>
																						<mat-select
																							class="has-selectionChange-handler"
																							(selectionChange)="handler_DropdownBlock_28_selectionChange_updateOutput_0($event, { resolution, resolutionIndex, $disabled: $disabled })"
																							[formControl]="$fc_28_1"
																							[compareWith]="$compare"
																							#select_28="matSelect"
																							[lgFormComponent]="select_28"
																							[lgFormValue]="resolution.chosenOption"
																							canSelectNullableOptions
																							[multiple]="false"
																						>
																							@let
																							emptyOption_28
																							= null;
																							@if
																							(emptyOption_28)
																							{
																							<mat-option
																								[value]="emptyOption_28[0]"
																								>{{
																								emptyOption_28[1]
																								}}</mat-option
																							>
																							}

																							<mat-option
																								*ngFor="let $option of (resolution.options); let $index = index"
																								[value]="$option"
																							>
																								<span
																									[innerHtml]="`${$option.id} ${$option.name}` | escapeHtml"
																									style="
																										margin: auto
																											0;
																									"
																								></span>
																							</mat-option>
																						</mat-select>
																					</mat-form-field>
																					<mat-form-field
																						*ngIf="$any(resolution.chosenOption)?.$isOther"
																					>
																						@let
																						$fc_28_3 =
																						getFormControl(resolution.chosenOption,
																						'$otherValue',
																						28, $scope,
																						$formDirective,
																						$disabled,
																						$ignoreValidations);
																						<mat-label
																							[innerHtml]="resolution.inputName + ' (Other)' | escapeHtml"
																						></mat-label>
																						<input
																							type="text"
																							matInput
																							[formControl]="$fc_28_3"
																						/>
																					</mat-form-field>

																					<div>
																						@let
																						$fc_45_1 =
																						getFormControl(resolution,
																						'isRemember',
																						45, $scope,
																						$formDirective,
																						$disabled,
																						$ignoreValidations);
																						<mat-checkbox
																							appearance="fill"
																							[formControl]="$fc_45_1"
																						>
																							{{
																							'Remember'
																							}}
																						</mat-checkbox>
																					</div>
																				</div></ng-container
																			>
																			<ng-template #else20>
																				<ng-container
																					*ngIf="resolution.options.length == 0"
																					><div
																						class="layout-block"
																						[style.align-items]="'baseline'"
																						[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																						[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																						[style.gap]="'1em'"
																					>
																						@let
																						$fc_34_1 =
																						getFormControl(resolution,
																						'chosenOption',
																						34, $scope,
																						$formDirective,
																						$disabled,
																						$ignoreValidations);
																						@let
																						displayWith_34
																						=
																						_SearchableDropdownBlock_displayWith_34;
																						<lowgile-searchable-dropdown
																							class="has-optionSelected-handler"
																							appearance="fill"
																							[class.not-found]="true"
																							[style.flex]="'1 0 auto'"
																							(optionSelected)="handler_SearchableDropdownBlock_34_optionSelected_$adhoc_0($event, { resolution, resolutionIndex, $disabled: $disabled }); handler_SearchableDropdownBlock_34_optionSelected_updateOutput_1($event, { resolution, resolutionIndex, $disabled: $disabled })"
																							[data]="_SearchableDropdownBlock_collectionCode_34($scope)"
																							[trackBy]="trackByAutomatic"
																							[label]="resolution.inputName"
																							[formControl]="$fc_34_1"
																							bindingMode="object"
																							[entity]=""
																							[minSearchLength]="3"
																							[maxResults]="20"
																							[displayWith]="displayWith_34"
																							[displayWithContext]="$scope"
																							[debouncingDelayMs]="0"
																							[findOptions]="null"
																							[allowClearing]="true"
																							[allClasses]="$Modules"
																							[emptySelection]="undefined"
																							[itemTemplate]="itemTemplate_34"
																						></lowgile-searchable-dropdown>
																						<ng-template
																							#itemTemplate_34
																							let-$option
																							let-$index="$index"
																						>
																							{{
																							displayWith_34($option,
																							$index,
																							$scope)
																							}}
																						</ng-template>

																						<div>
																							@let
																							$fc_44_1
																							=
																							getFormControl(resolution,
																							'isRemember',
																							44,
																							$scope,
																							$formDirective,
																							$disabled,
																							$ignoreValidations);
																							<mat-checkbox
																								appearance="fill"
																								[formControl]="$fc_44_1"
																							>
																								{{
																								'Remember'
																								}}
																							</mat-checkbox>
																						</div>
																					</div>
																					<ng-container
																						*ngIf="resolution.isRemember"
																						><span
																							style="
																								color: orange;
																								font-size: 80%;
																								text-decoration: italic;
																							"
																							[innerHtml]="'(&quot;Remember&quot; currently does\'nt have an impact on the functionality)' | escapeHtml: 'none' | replaceNewlines: 'span'"
																						></span
																					></ng-container>
																				</ng-container> </ng-template
																		></ng-container>
																	</ng-container>
																</ng-container>
															</ng-container>
														</div></div
												></ng-container>
											</div>
											<div
												class="layout-block vertical"
												[style.grid-column]="'span ' + (1)"
												[style.align-items]="'inherit'"
												[style.gap]="'1em'"
											>
												<ng-container
													*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(true)) as $disabled"
												>
													<mat-form-field appearance="fill">
														@let $fc_6_1 = getFormControl(screen,
														'companiesOutput', 6, $scope,
														$formDirective, $disabled,
														$ignoreValidations);
														<mat-label
															[innerHtml]="'Companies found' | escapeHtml"
														></mat-label>
														<textarea
															#input_6
															[formControl]="$fc_6_1"
															matInput
															[rows]="20"
														></textarea>

														<button
															*ngIf="input_6.value == ''"
															mat-icon-button
															matSuffix
															(click)="input_6.value = ''; $dispatchInputEvent(input_6)"
														>
															<mat-icon>close</mat-icon>
														</button>
													</mat-form-field>
												</ng-container>
												<ng-container
													*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!screen.companiesOutput)) as $disabled"
												>
													<div
														class="layout-block"
														[style.align-items]="'inherit'"
														[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
														[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
														[style.gap]="'1em'"
													>
														<mat-form-field
															class="has-selectionChange-handler"
															appearance="fill"
															(selectionChange)="handler_DropdownBlock_22_selectionChange_updateOutput_0($event, { $disabled: $disabled })"
														>
															@let $fc_22_1 =
															getFormControl(screen.outputType, 'id',
															22, $scope, $formDirective, $disabled,
															$ignoreValidations);

															<mat-label
																[innerHtml]="'Output type' | escapeHtml"
															></mat-label>
															<mat-select
																class="has-selectionChange-handler"
																(selectionChange)="handler_DropdownBlock_22_selectionChange_updateOutput_0($event, { $disabled: $disabled })"
																[formControl]="$fc_22_1"
																[compareWith]="$compare"
																#select_22="matSelect"
																[lgFormComponent]="select_22"
																[lgFormValue]="screen.outputType.id"
																canSelectNullableOptions
																[multiple]="false"
															>
																@let emptyOption_22 = null; @if
																(emptyOption_22) {
																<mat-option
																	[value]="emptyOption_22[0]"
																	>{{ emptyOption_22[1]
																	}}</mat-option
																>
																}

																<mat-option
																	*ngFor="let $option of (This.CompanyNameMatchingOutputType.getEntryList()); let $index = index"
																	[value]="$option.id"
																>
																	<span
																		[innerHtml]="$option.label | escapeHtml"
																		style="margin: auto 0"
																	></span>
																</mat-option>
															</mat-select>
														</mat-form-field>
														<mat-form-field
															*ngIf="$any(screen.outputType.id)?.$isOther"
														>
															@let $fc_22_3 =
															getFormControl(screen.outputType.id,
															'$otherValue', 22, $scope,
															$formDirective, $disabled,
															$ignoreValidations);
															<mat-label
																[innerHtml]="'Output type' + ' (Other)' | escapeHtml"
															></mat-label>
															<input
																type="text"
																matInput
																[formControl]="$fc_22_3"
															/>
														</mat-form-field>

														<button
															mat-raised-button
															class="has-click-handler"
															color="primary"
															(click)="handler_ButtonBlock_26_click_$adhoc_0($event, { $disabled: $disabled })"
															[disabled]="$disabled"
														>
															<mat-icon>{{'content_copy'}}</mat-icon
															><span
																[innerHtml]="'Copy to clipboard' | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</button>
													</div>
												</ng-container>
											</div></div
									></ng-container>
									<ng-template #else56>
										<h2
											[innerHtml]="'Click icon at the top right to log in' | escapeHtml: 'none' | replaceNewlines: 'h2'"
										></h2>
									</ng-template>
								</div>
							</div>
						</ng-container>
					</ng-template>
				</Toolbox-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
